import { extend, $, $$, addEvent } from './HelperFunctions'

export class PageHeader {
  constructor (settings, selectors, classes) {
    this.settings = extend({
      ScrollPositionForSticky: 0
    }, settings)

    this.selectors = extend({
      page: '.page',
      block: '.page-header',
      buttonBurger: '.page-header .button-burger',
      close: '.page-header__close'
    }, selectors)

    this.classes = extend({
      sticky: 'is--sticky',
      open: 'is--open',
      active: 'is--active',
      pageBlur: 'page--blur-content-footer'
    }, classes)

    this.$page = $(this.selectors.page)
    this.$pageHeader = $(this.selectors.block)
    this.$close = $$(this.selectors.close)
  }

  init () {
    this.events()
    this.setStickyPosition()
    this.checkIfSticky()
  }

  events () {
    const buttonBurger = $(this.selectors.buttonBurger)

    addEvent(buttonBurger, 'click', () => {
      if (this.$pageHeader.classList.contains(this.classes.open)) {
        this.close()
      } else {
        this.open()
      }
    })

    this.$close.forEach((close) => {
      addEvent(close, 'click', () => {
        this.close()

        buttonBurger.classList.remove(this.classes.active)
      })
    })

    addEvent(window, 'resize', () => {
      this.setStickyPosition()
      this.checkIfSticky()
    })

    addEvent(window, 'scroll', () => {
      this.checkIfSticky()
    })
  }

  setStickyPosition () {
    this.$page.classList.remove(this.classes.sticky)
    this.$pageHeader.dataset.stickyPosition = this.$pageHeader.getBoundingClientRect().height
  }

  checkIfSticky () {
    const stickyPosition = this.settings.ScrollPositionForSticky || this.$pageHeader.dataset.stickyPosition

    if (window.pageYOffset > stickyPosition) {
      this.$page.classList.add(this.classes.sticky)
    } else {
      this.$page.classList.remove(this.classes.sticky)
    }
  }

  open () {
    this.$pageHeader.classList.add(this.classes.open)
    this.$page.classList.add(this.classes.pageBlur)
  }

  close () {
    this.$pageHeader.classList.remove(this.classes.open)
    this.$page.classList.remove(this.classes.pageBlur)
  }
}

export default PageHeader
